import { SectionCard } from "@tine/designsystem-ui-react";
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { Link } from "wouter";
import { sendSelectTeaser, sendViewTeaser } from "../../common/tracking";
import type { ContentfulArticle, ContentfulImageWithFocus, ImageWithFocusData } from "../../common/types/cmsTypes";
import { fromContentToImageWithFocus } from "../../common/utils/imageUtils";
import contentStore from "../../stores/cms/contentStore";

type PromotionTeaserProps = {
   article: ContentfulArticle;
   imagePosition: "Left" | "Right";
};

const PromotionTeaser = ({ article, imagePosition }: PromotionTeaserProps) => {
   const [image, setImage] = useState<ImageWithFocusData | undefined>();

   const id = article.sys.id;
   const title = article.fields.title || "";
   const description = article.fields.preface || "";
   const ctaLabel = article.fields.callToActionSubTitle || article.fields.title || "";
   const urlData = contentStore.urlData.data.find((urlData) => urlData.id === id);
   const url = `/${urlData?.fullUrl}`;
   const teaserImage = article.fields.headerImage as ContentfulImageWithFocus;
   const contentType = article.sys.contentType.sys.id;

   useEffect(() => {
      const fetchImage = async () => {
         if (teaserImage.fields && contentStore.isPreviewMode) {
            const image = fromContentToImageWithFocus(teaserImage);
            setImage(image);
         } else {
            const imageWithFocus = await contentStore.getImageWithFocusUsingCache(teaserImage.sys.id);
            setImage(imageWithFocus);
         }
      };
      void fetchImage();
   }, [id]);

   const trackImpression = (isVisible: boolean) => {
      if (isVisible) {
         sendViewTeaser(title, contentType);
      }
   };

   const { ref: viewRef } = useInView({
      triggerOnce: true,
      onChange: trackImpression
   });

   return (
      <div ref={viewRef} className="relative">
         <div className="relative py-8 lg:py-10">
            <SectionCard
               title={title}
               description={description}
               image={image?.originalAssetUrl}
               imageAlt={title}
               ctaLabel={ctaLabel}
               href={url}
               linkComponent={Link}
               backgroundColor="transparent"
               buttonVariant="primary"
               isImageFlipped={imagePosition === "Right"}
               className="[&_strong]:font-semibold"
               onCtaClick={() => sendSelectTeaser(title, contentType, undefined, url)}
               defaultTagVariant="information"
            />
         </div>
      </div>
   );
};

export default PromotionTeaser;
